import { z } from "zod";
import { DbCreateInputOmit } from "../../helpers";

export const AssetReference = z.object({
  id: z.string(),
  designSystemVersionId: z.string(),
  assetId: z.string(),
  persistentId: z.string(),
});

export type AssetReference = z.infer<typeof AssetReference>;

export type CreateAssetReference = DbCreateInputOmit<AssetReference>;

export type AssetReferenceDiff = {
  toCreate: CreateAssetReference[];
  toDelete: string[];
};
